import AppContext from "../../AppContext";
import "./profilPage.css";
import {
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getPayment,
  fetchActiveProduct,
  getPaymentUrl,
  markPaymentAsSuccessful,
  pullUserData,
  saveUserData,
  sendVerificationEmail,
  reloadAuthData,
  getPublicUrlOfFile,
  fetchFileFromUrl,
  uploadImageToDb,
  uploadInstagramPhotoToDb,
  addAboutToDb,
  getHallOfFameUsers,
  getHallOfFameUser,
  writeTokenToDb,
  getConcurrentLoginToken,
  fbLogout,
} from "../../db/firebaseMethods";
import { Link, Navigate } from "react-router-dom";
import {
  PAYMENT_HOST,
  YEARS,
  HALICI_PAYMENT_HOST,
  CITIES,
  EDUCATIONS,
  OCCUPATIONS,
} from "../../common/constants";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import HistoryIcon from "@mui/icons-material/History";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";
import Grid from "@mui/material/Grid";

import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../utils/canvasUtils";
import { formatShippingAddress } from "../../utils/utils";
import { ListAltOutlined } from "@mui/icons-material";
import CryptoJS from "crypto-js";
import ExamPhotoUploadBox from "../../components/organisms/ExamPhotoUploadBox";
import { FinalSebfDocument2026 } from "../../components/organisms/pdfs/2026/02_finalSebfDocument";
import { KatilimSebfDocument2026 } from "../../components/organisms/pdfs/2026/03_katilimSebfDocument";
import { SinavSalonuDocument2026 } from "../../components/organisms/pdfs/2026/01_sinavSalonuDocument";

// Final Sınavı puan itiraz formu son tarihi: 10 Ekim 2026 15.30 (Türkiye saati)
const FINAL_OBJECTION_DEADLINE = new Date("2026-10-10T15:30:00+03:00");

// Şeref Kürsüsü özgeçmiş/fotoğraf güncelleme son tarihi: 21 Ekim 2026 23.59 (Türkiye saati)
const HOF_UPDATE_DEADLINE = new Date("2026-10-21T23:59:59+03:00");

// Kargo adresi formu açık/kapalı. Kapalıyken (false) formun yerine
// bilgilendirme notu (ShippingInfoNotice) gösterilir.
const SHIPPING_FORM_ENABLED = true;

const InfoBox = ({ title, content }) => {
  return (
    <div className="infoBox">
      <h3 className="infoBoxTitle">{title}</h3>
      <p className="infoBoxContent">{content}</p>
    </div>
  );
};

const toNamePascalCase = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(
      (word) =>
        word.charAt(0).toLocaleUpperCase("tr-TR") +
        word.slice(1).toLocaleLowerCase("tr-TR")
    )
    .join(" ");
};

export default function ProfilePage() {
  const { setCentralState, user, activeProduct, refreshUserData } =
    React.useContext(AppContext);

  if (!user) {
    return null;
  }
  // console.log({ user });
  // console.log(activeProduct);
  if (!user.emailVerified) return GenerateEmailVerificationBox();

  // GriCeviz Turnuvası Kullanım Kılavuzu kutusu
  const gricevizKlavuzKutu = (
    <div
      style={{
        border: "solid #b0bec5 3px",
        background: " #f2f2f2",
        padding: "20px",
        margin: "20px 0",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          color: "#582b71",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        GriCeviz Turnuvası Kullanım Kılavuzu
      </div>
      <div
        style={{
          fontSize: 15,
          marginBottom: 18,
          color: "#333",
          textAlign: "center",
          maxWidth: 500,
        }}
      >
        GriCeviz Turnuvası'na katılım ve platformun kullanımıyla ilgili detaylı
        bilgi için aşağıdaki kılavuzu inceleyebilirsiniz. Tüm adımlar ve
        platforma giriş hakkında önemli bilgiler bu dosyada yer
        almaktadır.Turnuvaya başlamadan önce GriCeviz uygulamasının son sürümünü
        kullandığınızdan emiin olunuz.
      </div>
      <a
        href="/assets/GriCeviz.pdf"
        target="_blank"
        rel="noopener noreferrer"
        download
        style={{ textDecoration: "none" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{
            fontWeight: "bold",
            fontSize: 17,
            padding: "12px 32px",
            borderRadius: 8,
            letterSpacing: 1,
          }}
        >
          KILAVUZU İNDİR
        </Button>
      </a>
    </div>
  );

  return (
    <div className="profilePageContainer">
      <h3 className="pageHeader">YARIŞMA SAYFASI</h3>
      {/* <h3>
        OYUN 2023 Yarışmasının kayıt ve başvuruları 1 Haziran 2023 Perşembe günü
        başlayacaktır. Aşağıda geçen yıla ait sınav ve belgelerinizi
        görüntüleyebilirsiniz.
      </h3> */}
      {GeneratePersonalInfoBox()}

      {/* Sosyal Etkinlik Bilgilendirme Formu */}
      {activeProduct?.id === "oyun2026" &&
        user.products?.[activeProduct?.id]?.is_paid &&
        (() => {
          const userProductData = user.products?.[activeProduct?.id];
          // SEBF yalnızca okul çağındaki (2009-2020 doğumlu) öğrencilere verilir.
          const isSchoolAge =
            user?.birth_year >= 2009 && user?.birth_year <= 2020;
          if (!isSchoolAge) {
            return null;
          }
          // Finalistlere (yf_sonuc === 1) başarı, diğerlerine katılım belgesi.
          const shouldShowFinalSebf = userProductData?.yf_sonuc === 1;

          return (
            <div
              className="infoBox"
              style={{
                marginTop: 24,
                marginBottom: 12,
                padding: 24,
                border: "2px solid #582b71",
                borderRadius: 12,
                background: "linear-gradient(135deg, #f9f5fc 0%, #f2eaf7 100%)",
                boxShadow: "0px 4px 12px rgba(88, 43, 113, 0.15)",
              }}
            >
              <h3
                className="infoBoxTitle"
                style={{
                  color: "#582b71",
                  fontSize: "1.6rem",
                  marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <span role="img" aria-label="Belge">
                  📄
                </span>
                Sosyal Etkinlik Bilgilendirme Formu
              </h3>
              <div className="infoBoxContent">
                <p
                  style={{
                    color: "#555",
                    fontSize: 15,
                    lineHeight: 1.6,
                    marginBottom: 20,
                    textAlign: "justify",
                  }}
                >
                  İlkokul, ortaokul ve lise öğrencileri için MEB sistemine
                  yüklenmek üzere hazırlanmış Sosyal Etkinlik Bilgilendirme
                  Formu (SEBF) belgenizi aşağıdaki butona tıklayarak
                  indirebilirsiniz. Bu belge, okul sisteminize yüklemek için
                  hazırlanmıştır.
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                    alignItems: "center",
                  }}
                >
                  {shouldShowFinalSebf ? (
                    <FinalSebfDocument2026
                      userName={user.name}
                      userId={user.uid}
                      fileNumber={userProductData?.file_number}
                    />
                  ) : (
                    <KatilimSebfDocument2026
                      userName={user.name}
                      userId={user.uid}
                      fileNumber={userProductData?.file_number}
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })()}

      {user.products?.[activeProduct?.id]?.is_paid && (
        <div
          className="infoBox"
          style={{
            marginTop: 24,
            marginBottom: 12,
            padding: 20,
            border: "2px solid #43a047",
            borderRadius: 12,
            textAlign: "center",
          }}
        >
          <h3 style={{ color: "#388e3c", marginBottom: 10 }}>
            OYUN 2026 Değerlendirme Anketi
          </h3>
          <p style={{ color: "#333", fontSize: 15, marginBottom: 18 }}>
            Yarışma deneyiminizi bizimle paylaşmak için aşağıdaki bağlantıdan
            OYUN 2026 değerlendirme anketini doldurabilirsiniz.
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScBLD5DzUKsRgi-Ts53M5eLbOLMXDQo9MbQD-K726jrgPEZYA/viewform?usp=dialog"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="secondary"
              style={{
                fontWeight: "bold",
                fontSize: 17,
                padding: "12px 32px",
                borderRadius: 8,
                textTransform: "none",
              }}
            >
              Anketi Doldur
            </Button>
          </a>
        </div>
      )}

      {user?.products?.[activeProduct?.id]?.final_derecesi <= 10 &&
        hallOfFameInputBox(user, activeProduct)}

      {user?.products?.[activeProduct?.id]?.final_derecesi <= 5 &&
        // Kargo formu yalnızca admin panelinden ödül tanımlananlara açılır
        (SHIPPING_FORM_ENABLED &&
        user?.products?.[activeProduct?.id]?.odul_gonderilecek === true ? (
          <ShippingAddressBox />
        ) : (
          <ShippingInfoNotice />
        ))}

      {GenerateActiveProductBox()}

      {/* {user.products?.[activeProduct?.id]?.is_paid &&
        activeProduct?.id === "oyun2026" &&
        user.products?.[activeProduct?.id]?.total_score !== undefined &&
        user.products?.[activeProduct?.id]?.total_rank !== undefined && (
          <div className="infoBox totalScoreBox">
            <h3
              className="infoBoxTitle"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              Toplam Sınav Sonuçları - Final Sınavına Katılma Durumu
            </h3>
            <div className="infoBoxContent">
              <p style={{ fontSize: "0.95em", color: "#000", marginBottom: 2 }}>
                Bu sonuçlar Birinci Aşama, GriCeviz Turnuvası ve Üçüncü Aşama
                sınav sonuçlarından elde edilen puandır.
              </p>
              <div
                style={{
                  background: "#f5f5f5",
                  padding: "12px",
                  borderRadius: 8,
                  marginBottom: 16,
                }}
              >
                <p
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    marginBottom: 8,
                    fontWeight: 600,
                  }}
                >
                  Puan Hesaplama Yöntemi:
                </p>
                <ul
                  style={{
                    fontSize: "0.85em",
                    color: "#666",
                    margin: 0,
                    paddingLeft: 20,
                  }}
                >
                  <li>Birinci Aşama Sınavı: %45</li>
                  <li>İkinci Aşama GriCeviz Turnuvası: %10</li>
                  <li>Üçüncü Aşama Sınavı: %45</li>
                </ul>
                <p
                  style={{
                    fontSize: "0.8em",
                    color: "#666",
                    marginTop: 8,
                    marginBottom: 0,
                  }}
                >
                  <strong>Not:</strong> Her aşama için en yüksek puan alan
                  yarışmacının puanı 100'e eşitlenecek şekilde oranlama yapılmış
                  ve diğer yarışmacıların puanları bu orana göre belirlenmiştir.
                  Üç aşamanın puanları yukarıdaki yüzdelerle toplanarak genel
                  başarı puanı hesaplanmıştır. Her kategoride en yüksek puanı
                  alan 100, toplamda 500 yarışmacı Final Sınavı'na katılmaya hak
                  kazanmıştır.
                </p>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    flexWrap: "wrap",
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      minWidth: 120,
                      flexShrink: 0,
                    }}
                  >
                    Toplam Puan:
                  </span>
                  <span
                    style={{
                      background: "#e8f5e8",
                      padding: "8px 16px",
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: "1.1em",
                      color: "#2d5a2d",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      flex: "1",
                      minWidth: 0,
                    }}
                  >
                    {user.products[activeProduct.id].total_score}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    flexWrap: "wrap",
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      minWidth: 120,
                      flexShrink: 0,
                    }}
                  >
                    Sıralama:
                  </span>
                  <span
                    style={{
                      background: "#e3f2fd",
                      padding: "8px 16px",
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: "1.1em",
                      color: "#1565c0",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      flex: "1",
                      minWidth: 0,
                    }}
                  >
                    {user.products[activeProduct.id].total_rank}
                  </span>
                </div>
              </div>
              {user.products[activeProduct.id].total_rank >= 1 &&
              user.products[activeProduct.id].total_rank <= 100 ? (
                <p
                  style={{
                    fontSize: "1.05em",
                    color: "#2e7d32",
                    marginTop: 20,
                    fontWeight: 600,
                    textAlign: "center",
                    padding: "12px",
                    background: "#e8f5e9",
                    borderRadius: 8,
                    border: "2px solid #66bb6a",
                  }}
                >
                  Tebrikler, Final Sınavı'na katılmaya hak kazandınız!
                </p>
              ) : (
                <p
                  style={{
                    fontSize: "1.05em",
                    color: "#c62828",
                    marginTop: 20,
                    fontWeight: 600,
                    textAlign: "center",
                    padding: "12px",
                    background: "#ffebee",
                    borderRadius: 8,
                    border: "2px solid #e57373",
                  }}
                >
                  Üzgünüz, Final Sınavı'na katılmaya hak kazanamadınız.
                </p>
              )}
            </div>
          </div>
        )} */}

      {/* GriCeviz Uygulaması Giriş Bilgileri kutusu
      {user.products?.[activeProduct?.id]?.is_paid && (
        <div className="infoBox gricevizLoginBox">
          <h3
            className="infoBoxTitle"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <span role="img" aria-label="Anahtar">
              🔑
            </span>{" "}
            GriCeviz Uygulaması Giriş Bilgileri
          </h3>
          <div className="infoBoxContent">
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ fontWeight: 600, minWidth: 110 }}>E-Posta:</span>
                <span
                  style={{
                    background: "#ece6f6",
                    padding: "6px 14px",
                    borderRadius: 8,
                    fontWeight: 500,
                  }}
                >
                  {user.email}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ fontWeight: 600, minWidth: 110 }}>Şifre:</span>
                <span
                  style={{
                    background: "#ece6f6",
                    padding: "6px 14px",
                    borderRadius: 8,
                    fontWeight: 500,
                    letterSpacing: "2px",
                  }}
                >
                  {user.uid?.slice(0, 6)}
                </span>
              </div>
            </div>
            <p style={{ fontSize: "0.95em", color: "#888", marginTop: 16 }}>
              Bu bilgilerle{" "}
              <a href="https://griceviz.com" target="_blank" rel="noreferrer">
                GriCeviz
              </a>{" "}
              platformuna giriş yapabilirsiniz.
            </p>
          </div>
        </div>
      )}*/}

      {/* {user.products?.[activeProduct?.id]?.is_paid &&
        user.products?.[activeProduct?.id]?.griceviz_result !== undefined && (
          <div className="infoBox gricevizResultsBox">
            <h3
              className="infoBoxTitle"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <span role="img" aria-label="Trophy">
                🏆
              </span>{" "}
              GriCeviz Turnuvası Sınav Sonuçları
            </h3>
            <div className="infoBoxContent">
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    flexWrap: "wrap",
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      minWidth: 120,
                      flexShrink: 0,
                    }}
                  >
                    Sınav Puanı:
                  </span>
                  <span
                    style={{
                      background: "#e8f5e8",
                      padding: "8px 16px",
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: "1.1em",
                      color: "#2d5a2d",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      flex: "1",
                      minWidth: 0,
                    }}
                  >
                    {user.products[activeProduct.id].griceviz_result} Puan
                  </span>
                </div>
              </div>
              <p style={{ fontSize: "0.95em", color: "#000", marginTop: 16 }}>
                Bu puan, GriCeviz turnuvası sonucunda aldığınız puandır.
              </p>

              <p style={{ fontSize: "0.95em", color: "#000" }}>
                Bu aşamada hiç kimse elenmemiştir. Kayıt işlemini tamamlayan tüm
                yarışmacılar, istisnasız olarak ilk 3 aşamaya katılma hakkı elde
                etmektedirler. Üçüncü Aşama Sınavı, 4 Ekim 2025, Cumartesi günü,
                saat 13.00-14.15 arasında oyun.tzv.org.tr adresi üzerinden
                çevrim içi olarak gerçekleştirilecektir. İlk 3 aşamadan alınan
                sonuçlara göre her kategoriden en yüksek dereceyi elde eden
                100'er yarışmacı, Ankara'da gerçekleştirilecek olan yazılı Final
                Sınavına (4. aşama) davet edilecektir.
              </p>
            </div>
          </div>
        )} */}
      {/* {user.products?.[activeProduct?.id]?.is_paid && (
        <ExamPhotoUploadBox
          user={user}
          refreshUserData={refreshUserData}
          uploadInstagramPhotoToDb={uploadInstagramPhotoToDb}
          saveUserData={saveUserData}
        />
      )} */}
      {/* {gricevizKlavuzKutu}

      <InfoBox
        title="🎯İkinci Aşama GriCeviz Turnuvası Bilgilendirme"
        content={
          <>
            <p>
              İkinci Aşama GriCeviz Turnuvası, <strong>10-17 Eylül 2025</strong>{" "}
              tarihleri arasında gerçekleştirilecektir.
            </p>
            <p>
              <strong>10-17 Eylül 2025</strong> tarihleri arasında ise GriCeviz
              Bilişsel Beceri ve Zihinsel Gelişim Platformu tüm katılımcılara
              ücretsiz olarak açık olacaktır. Bu süre zarfında platforma
              erişerek sistemi önceden tanıyabilir ve nasıl kullanılacağı
              hakkında bilgi edinebilirsiniz.
            </p>
            <p>
              GriCeviz platformuna erişim sağlarken aşağıdaki bilgilere dikkat
              etmeniz önemlidir:
            </p>

            <ul>
              <li>
                Kullanıcı bilgileriniz (e-posta ve şifre) profil sayfanıza
                turnuva öncesinde tanımlanacaktır. Sisteme tanımlanan bu
                bilgilerle giriş yapabilirsiniz.
              </li>
              <li>
                Sisteme yalnızca bir kez giriş yapabilirsiniz. İlk girişinizin
                ardından turnuvaya tekrar katılım mümkün olmayacaktır.
              </li>
              <li>
                Girişte herhangi bir sorun yaşamanız durumunda teknik destek
                sağlanacaktır.
              </li>
              <li>
                Turnuva soruları yaş/kategori düzeyinize uygun şekilde
                hazırlanmıştır ve çeşitli bilişsel becerilerinizi ölçmeyi
                hedeflemektedir.
              </li>
            </ul>
            <p>
              🔗 Aşağıdaki bağlantıya tıklayarak GriCeviz platformuna
              ulaşabilirsiniz:
            </p>
            <a
              href="https://griceviz.com"
              target="_blank"
              rel="noreferrer"
              className="gricevizButton"
            >
              👉 GriCeviz'e Git
            </a>
          </>
        }
      />*/}
    </div>
  );
}

const GenerateEmailVerificationBox = () => {
  const { user, setCentralState } = React.useContext(AppContext);

  const checkForVerificationStatus = async () => {
    // Tekrar link göndermeden önce bi kez daha kontrol edelim, belki başka sekmeden doğrulama yapılmıştır

    await reloadAuthData(user, setCentralState);
    // await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
    // console.log("user after 3 seconds", user);
    // if(!user.emailVerified){
    //     console.log("user in re-verify buton after refresh:", user);
    //     // await sendVerificationEmail();
    //     alert("Doğrulama linki e-posta adresinize gönderildi. Lütfen kontrol ediniz.");
    // }
    // else{
    //     alert("Doğrulama başarılı. Profil sayfanıza yönlendirileceksiniz.");
    // }
  };

  return (
    <div className="verificationBox">
      <p>
        {" "}
        {user.email + " e-posta adresinize bir doğrulama linki gönderdik."}
      </p>
      <p>
        Sınavlara erişebilmek için lütfen e-posta kutunuza giderek size
        gönderilen doğrulama linkine tıklayınız.
      </p>

      <div className="verificationbuttonDiv">
        <Button
          variant="contained"
          onClick={() => checkForVerificationStatus()}
        >
          Doğrulama Linkini Tekrar Gönder
        </Button>
      </div>
    </div>
  );
};

const GeneratePersonalInfoBox = () => {
  const {
    refreshUserData,
    setCentralState,
    user,
    activeProduct,
    userDataLoadError,
  } = React.useContext(AppContext);
  const [editModeEnabled, setEditMode] = useState(false);
  const [newName, setName] = useState(user?.name || "");
  const [newPhone, setPhone] = useState(user?.phone || "");
  const [gender, setGender] = useState(user?.gender || "");
  const [city, setCity] = useState(user?.city || "");
  const [education, setEducation] = useState(user?.education || "");
  const [occupation, setOccupation] = useState(user?.occupation || "");
  const [newBirthYear, setBirthYear] = useState(user?.birth_year || 0);
  const [carPlate, setCarPlate] = useState(user?.car_plate || "");
  const [isLoading, setLoading] = useState(false);

  const generateScreenId = (userId) => {
    const hash = CryptoJS.SHA256(userId + "oyun").toString();
    return `${userId}oyun${hash.substring(0, 5)}`;
  };
  const screenId = user ? generateScreenId(user.uid) : "";
  const documentsUrl = `https://belge-yonetim.web.app/screens/${screenId}`;

  const isAllCompulsaryFieldsFilled =
    user &&
    user.name &&
    user.birth_year &&
    user.gender &&
    user.city &&
    user.education &&
    user.occupation;
  user.car_plate;

  const birthYearLocked = !!user.birth_year;

  //if (!user) return null;

  useEffect(() => {
    if (user) {
      setName(user.name || "");
      setPhone(user.phone || "");
      setGender(user.gender || "");
      setCity(user.city || "");
      setEducation(user.education || "");
      setOccupation(user.occupation || "");
      setBirthYear(user.birth_year || "");
      setCarPlate(user.car_plate || "");
    }
  }, [user?.uid, user?.name]);

  if (!user) return null;

  const saveProfileData = async (id, data) => {
    let missingFields = [];
    [
      newName,
      newPhone,
      gender,
      city,
      education,
      occupation,
      newBirthYear,
      //carPlate,
    ].forEach((f) => {
      if (!f) missingFields.push(f);
    });

    if (missingFields?.length > 0) {
      alert("Lütfen tüm bilgileri doldurunuz!");
    } else {
      setLoading(true);
      await saveUserData(id, data);
      await refreshUserData();
      setLoading(false);
      setEditMode(false);
    }
  };

  if (userDataLoadError) {
    return (
      <div className="personelInfoBox">
        {isLoading && <LoadingBlock />}
        <p>
          <strong>Profil bilgileriniz yüklenemedi.</strong> Lütfen internet
          bağlantınızı kontrol edip "Yeniden Dene" butonuna basınız. Sorun devam
          ederse bu ekranın görüntüsünü alarak bize iletiniz.
        </p>
        <div
          style={{
            fontFamily: "monospace",
            fontSize: 12,
            background: "#fff3f3",
            border: "1px solid #e0b4b4",
            borderRadius: 4,
            padding: 8,
            marginBottom: 12,
            wordBreak: "break-word",
          }}
        >
          <div>Hata kodu: {userDataLoadError.code}</div>
          <div>Hata mesajı: {userDataLoadError.message}</div>
          <div>E-posta: {user.email}</div>
          <div>Kullanıcı ID: {user.uid}</div>
          <div>Zaman: {userDataLoadError.time}</div>
          <div>Tarayıcı: {navigator.userAgent}</div>
        </div>
        <Button
          variant="outlined"
          color="secondary"
          onClick={async () => {
            setLoading(true);
            await refreshUserData();
            setLoading(false);
          }}
        >
          Yeniden Dene
        </Button>
      </div>
    );
  }

  if (editModeEnabled || !isAllCompulsaryFieldsFilled) {
    return (
      <div className="personelInfoBox">
        {isLoading && <LoadingBlock />}
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 16 }}
        ></div>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="newName"
              label="Adı-Soyadı"
              name="newName"
              defaultValue={newName}
              value={newName}
              onChange={(e) => setName(toNamePascalCase(e.target.value))}
              autoComplete={"disabled"}
              style={{ width: 250 }}
              size="small"
              error={newName.length < 3}
              //disabled
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="newPhone"
              label="Telefon Numarası"
              name="newPhone"
              defaultValue={newPhone}
              value={newPhone}
              onChange={(e) => setPhone(e.target.value)}
              autoComplete={"disabled"}
              style={{ width: 250 }}
              size="small"
              error={newPhone.length < 10}
              //disabled
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              id="yearChooser"
              defaultValue={user.birthYear}
              value={newBirthYear}
              onChange={(e) => setBirthYear(e.target.value)}
              label="Doğum Yılı"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!newBirthYear}
              disabled={birthYearLocked}
            >
              {YEARS.map((y) => (
                <MenuItem key={y + "yil_menu"} value={y}>
                  {y}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              id="genderChooser"
              error={!gender}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              label="Cinsiyet"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              //disabled
            >
              <MenuItem value="Kadın">Kadın</MenuItem>
              <MenuItem value="Erkek">Erkek</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              label="Şehir"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!city}
              //disabled
            >
              {CITIES.map((c) => (
                <MenuItem key={c + "city_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              error={!education}
              select
              value={education}
              onChange={(e) => setEducation(e.target.value)}
              label="Eğitim Durumu"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              //disabled
            >
              {EDUCATIONS.map((c) => (
                <MenuItem key={c + "education_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={occupation}
              onChange={(e) => setOccupation(e.target.value)}
              label="Meslek"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!occupation}
              //disabled
            >
              {OCCUPATIONS.map((c) => (
                <MenuItem key={c + "occupation_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="carPlate"
              label="Araç Plakası (Final İçin)"
              placeholder="Finale Gelecekler İçindir"
              name="carPlate"
              defaultValue={carPlate}
              value={carPlate}
              onChange={(e) => setCarPlate(e.target.value)}
              autoComplete={"disabled"}
              style={{ width: 250 }}
              size="small"
            />
          </Grid>

          <Grid item xs={12}>
            <div className="profileButtonsContainer">
              <div className="profileButtons">
                <Button
                  variant="outlined"
                  onClick={() => {
                    setEditMode(false);
                  }}
                >
                  Vazgeç
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() =>
                    saveProfileData(user.uid, {
                      name: newName,
                      phone: newPhone,
                      gender: gender,
                      city: city,
                      education: education,
                      occupation: occupation,
                      birth_year: birthYearLocked
                        ? user.birth_year
                        : newBirthYear,
                      car_plate: carPlate,
                    })
                  }
                >
                  Kaydet
                </Button>
                {/*<Button variant="outlined" color="secondary" disabled>
                  Kaydet
                </Button>*/}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return (
      <div className="personelInfoBox">
        <div className="labelRow">
          <div className="label">E-Posta</div>
          <span>{user.email}</span>
        </div>
        <div className="labelRow">
          <div className="label">Adı-Soyadı </div>
          <span>{user.name}</span>{" "}
        </div>
        <div className="labelRow">
          <div className="label">Telefon </div>
          <span>{user.phone}</span>{" "}
        </div>
        <div className="labelRow">
          <div className="label">Doğum Yılı </div>
          <span>{user.birth_year}</span>
        </div>
        <div className="buttonsspace">
          <a href={documentsUrl} target="_blank" rel="noopener noreferrer">
            <Button
              className="historyButton"
              style={{ marginTop: 20 }}
              startIcon={<ListAltOutlined />}
            >
              BELGELERİM
            </Button>
          </a>
          {/* <Link to="/documents">
            <Button className="historyButton">
              <HistoryIcon style={{ marginRight: 5, fontSize: 18 }} />

              {"Belgelerim".toLocaleUpperCase("tr-TR")}
            </Button>
          </Link> */}
          <Button
            className="editButton"
            variant="contained"
            onClick={() => {
              setEditMode(true);
            }}
          >
            <EditIcon style={{ fontSize: 18, marginRight: 3 }} /> Düzenle
          </Button>
        </div>
      </div>
    );
  }
};

// İlk 5'e girenlerden ödül gönderimi için kargo adresi alınır.
// Adres kullanıcı dokümanına (products.<sezon>.kargo_adresi) yazılır; hall_of_fames
// herkese açık olduğu için oraya yazılmaz.
const SHIPPING_FIELDS = [
  {
    key: "alici",
    label: "Alıcı Ad-Soyad",
    required: true,
    sm: 6,
    helper: "18 yaşından küçükseniz velinizin adını yazabilirsiniz.",
  },
  { key: "telefon", label: "Telefon", required: true, sm: 6 },
  { key: "il", label: "İl", required: true, sm: 6, options: CITIES },
  { key: "ilce", label: "İlçe", required: true, sm: 6 },
  { key: "mahalle", label: "Mahalle", required: true, sm: 6 },
  { key: "sokak", label: "Cadde / Sokak", required: true, sm: 6 },
  { key: "bina_no", label: "Bina / Kapı No", required: true, sm: 4 },
  {
    key: "daire_no",
    label: "Daire No",
    required: true,
    sm: 4,
    helper: "Müstakil evlerde kapı numaranızı yazabilirsiniz.",
  },
  { key: "posta_kodu", label: "Posta Kodu", sm: 4 },
  {
    key: "adres_tarifi",
    label: "Adres Tarifi (site/apartman adı, blok, kat vb.)",
    sm: 12,
    multiline: true,
  },
];

const ShippingInfoNotice = () => (
  <div
    className="hallOfFameBox"
    style={{
      border: "2.5px solid #582b71",
      borderRadius: 22,
      margin: "30px 0",
      padding: 30,
      textAlign: "center",
    }}
  >
    <p
      style={{
        fontWeight: 800,
        fontSize: 22,
        color: "#582b71",
        marginBottom: 12,
      }}
    >
      Ödül Gönderimi Hakkında
    </p>
    <p style={{ color: "#555", lineHeight: 1.7, margin: 0 }}>
      Düzenleme Kurulumuzun aldığı karar doğrultusunda ilk 5 sıralaması yeniden
      düzenlenmiştir. Ödül alacak katılımcılarımızın kargo bilgileri en kısa
      sürede alınacak ve ödüllerin gönderimi yapılacaktır.
    </p>
  </div>
);

const ShippingAddressBox = () => {
  const { user, activeProduct, refreshUserData } = useContext(AppContext);
  const productData = user?.products?.[activeProduct?.id];
  const saved = productData?.kargo_adresi;
  const isReceived = !!productData?.kargo_teslim_alindi;
  const [form, setForm] = useState(() => {
    // Alıcı genelde veli olduğu için ad-soyad önceden doldurulmaz
    const defaults = {
      telefon: user?.phone,
      il: user?.city,
    };
    return Object.fromEntries(
      SHIPPING_FIELDS.map(({ key }) => [
        key,
        saved?.[key] || defaults[key] || "",
      ])
    );
  });
  const [isEditing, setIsEditing] = useState(!saved);
  const [isSaving, setIsSaving] = useState(false);

  const setField = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleSave = async () => {
    const trimmed = Object.fromEntries(
      Object.entries(form).map(([k, v]) => [k, v.trim()])
    );
    const missing = SHIPPING_FIELDS.filter(
      (f) => f.required && !trimmed[f.key]
    );
    if (missing.length > 0) {
      alert(
        "Lütfen şu alanları doldurunuz: " +
          missing.map((f) => f.label).join(", ")
      );
      return;
    }
    if (trimmed.telefon.replace(/\D/g, "").length < 10) {
      alert("Lütfen geçerli bir telefon numarası giriniz.");
      return;
    }
    if (trimmed.posta_kodu && !/^\d{5}$/.test(trimmed.posta_kodu)) {
      alert("Posta kodu 5 haneli olmalıdır.");
      return;
    }
    setIsSaving(true);
    try {
      await saveUserData(user.uid, {
        products: {
          [activeProduct.id]: {
            kargo_adresi: { ...trimmed, updated_at: new Date() },
          },
        },
      });
      await refreshUserData();
      setIsEditing(false);
      alert("Kargo adresiniz kaydedildi.");
    } catch (err) {
      alert("Kargo adresi kaydedilirken bir hata oluştu.");
    }
    setIsSaving(false);
  };

  const handleReceivedChange = async (e) => {
    const checked = e.target.checked;
    if (
      checked &&
      !window.confirm("Ödülünüzü teslim aldığınızı onaylıyor musunuz?")
    )
      return;
    setIsSaving(true);
    try {
      await saveUserData(user.uid, {
        products: {
          [activeProduct.id]: {
            kargo_teslim_alindi: checked,
            kargo_teslim_tarihi: checked ? new Date() : null,
          },
        },
      });
      await refreshUserData();
    } catch (err) {
      alert("Teslim bilgisi kaydedilirken bir hata oluştu.");
    }
    setIsSaving(false);
  };

  return (
    <div
      className="hallOfFameBox"
      style={{
        border: "2.5px solid #582b71",
        borderRadius: 22,
        margin: "30px 0",
        padding: 30,
      }}
    >
      <p
        style={{
          fontWeight: 800,
          fontSize: 22,
          color: "#582b71",
          textAlign: "center",
          marginBottom: 8,
        }}
      >
        Ödül Gönderimi İçin Kargo Adresi
      </p>
      <p style={{ textAlign: "center", color: "#555", marginBottom: 12 }}>
        Kategorinizde ilk 5'e girdiğiniz için ödülünüz kargo ile
        gönderilecektir. Dereceye giren kişi sayısı beklenenden fazla olduğu
        için kargolama süresi değişkenlik gösterebilir.
      </p>
      <div
        style={{
          background: "#fdf0e0",
          border: "1px solid #f0c080",
          color: "#8a4b00",
          borderRadius: 10,
          padding: "10px 14px",
          marginBottom: 20,
          textAlign: "center",
          fontSize: 14,
        }}
      >
        <strong>Lütfen okul adresi vermeyiniz.</strong> Kargonun veli tarafından
        teslim alınması gerekmektedir; iade işlemleri süreci uzatmaktadır.
      </div>

      {saved && !isEditing && (
        <div style={{ textAlign: "center", lineHeight: 1.7 }}>
          <div>
            <strong>{saved.alici}</strong> — {saved.telefon}
          </div>
          <div>{formatShippingAddress(saved)}</div>
          <div>
            {saved.posta_kodu && saved.posta_kodu + " "}
            {saved.ilce} / {saved.il}
          </div>
          {!isReceived && (
            <Button
              style={{ marginTop: 12 }}
              variant="outlined"
              color="secondary"
              onClick={() => setIsEditing(true)}
            >
              Adresi Güncelle
            </Button>
          )}
          <div
            style={{
              marginTop: 16,
              paddingTop: 12,
              borderTop: "1px solid #eee",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={isReceived}
                  disabled={isSaving}
                  onChange={handleReceivedChange}
                />
              }
              label={
                <strong style={{ color: isReceived ? "#2e7d32" : "#582b71" }}>
                  {isReceived
                    ? "Ödülümü teslim aldım ✓"
                    : "Ödülümü teslim aldım"}
                </strong>
              }
            />
            {!isReceived && (
              <div style={{ fontSize: 13, color: "#777" }}>
                Kargonuz elinize ulaştığında lütfen bu kutucuğu işaretleyiniz.
              </div>
            )}
          </div>
        </div>
      )}

      {isEditing && (
        <Grid container spacing={2}>
          {SHIPPING_FIELDS.map((f) => (
            <Grid item xs={12} sm={f.sm} key={"shipping_" + f.key}>
              <TextField
                fullWidth
                required={f.required}
                select={!!f.options}
                multiline={f.multiline}
                minRows={f.multiline ? 2 : undefined}
                label={f.label}
                helperText={f.helper}
                value={form[f.key]}
                onChange={setField(f.key)}
              >
                {f.options?.map((c) => (
                  <MenuItem key={c + "shipping_city"} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ))}
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Button
              variant="contained"
              color="secondary"
              disabled={isSaving}
              onClick={handleSave}
            >
              {isSaving ? "Kaydediliyor..." : "Kargo Adresini Kaydet"}
            </Button>
            {saved && (
              <Button
                style={{ marginLeft: 8 }}
                disabled={isSaving}
                onClick={() => setIsEditing(false)}
              >
                Vazgeç
              </Button>
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const hallOfFameInputBox = (user, season) => {
  const { activeProduct } = useContext(AppContext);
  const [about, setAbout] = useState(user?.about || "");
  const [modalOpen, setModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);
  const [isHofInfoLoading, setIsHofInfoLoading] = useState(false);
  const [showUserHallOfFamesComponents, setShowUserHallOfFamesComponents] =
    useState({
      showCongratTitle: true,
      showHallOfFameBox: true,
    });

  const imageUploaderRef = useRef(null);

  useEffect(() => {
    getHallOfFameUser(activeProduct?.id, user.uid).then((user) => {
      if (user.about) {
        setShowUserHallOfFamesComponents({
          showCongratTitle: false,
          showHallOfFameBox: false,
        });
      }
    });
  }, [activeProduct?.id]);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };
  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      setModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };
  function handlefocusback() {
    setIsPhotoUploading(false);

    window.removeEventListener("focus", handlefocusback);
  }
  const onFileInputClicked = () => {
    setIsPhotoUploading(true);
    imageUploaderRef.current.value = null;
    setImageSrc(null);
    setCroppedImage(null);
    window.addEventListener("focus", handlefocusback);
  };
  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }
  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setModalOpen(true);
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
    }
    setIsPhotoUploading(false);
  };

  const handleModalClose = () => {
    imageUploaderRef.current.value = null;
    setModalOpen(false);
    setIsPhotoUploading(false);
  };

  const isHofUpdateOpen = new Date() < HOF_UPDATE_DEADLINE;
  const hofYear = season?.id?.replace("oyun", "");

  const handleSubmitHallOfFameInfo = async () => {
    if (!isHofUpdateOpen) {
      alert("Şeref Kürsüsü bilgi güncelleme süresi sona ermiştir.");
      return;
    }
    if (about.trim().length < 100) {
      alert("Lütfen özgeçmişinizi en az 100 karakter olarak doldurunuz.");
      return;
    }
    setIsHofInfoLoading(true);
    let photoURL = "";
    if (croppedImage) {
      const pureData = croppedImage.split(",")[1];
      var sizeInBytes = 4 * Math.ceil(pureData.length / 3) * 0.5624896334383812;
      var sizeInKb = sizeInBytes / 1000;
      if (sizeInKb > 20 * 1024) {
        alert("Fotoğraf boyutu 20MB'dan büyük olamaz.");
        return;
      }
      photoURL = await uploadImageToDb(
        croppedImage.split(",")[1],
        user.uid,
        season.id
      );
    }

    try {
      await addAboutToDb(about.trim(), season.id, user.uid, photoURL);
      setAbout("");
      setCroppedImage(null);
      setShowUserHallOfFamesComponents({
        showCongratTitle: false,
        showHallOfFameBox: false,
      });
      alert("Özgeçmişiniz başarıyla kaydedildi.");
    } catch (error) {
      alert("Özgeçmişiniz kaydedilirken bir hata oluştu.");
    }
    setIsHofInfoLoading(false);
  };

  return (
    <>
      <div
        className="hallOfFameBox"
        style={{
          boxShadow:
            "0 6px 32px 0 rgba(68,118,211,0.12), 0 1.5px 4px 0 rgba(0,0,0,0.08)",
          border: "2.5px solid #582b71",
          borderRadius: 22,
          margin: "30px 0",
          padding: 38,
        }}
      >
        <p
          className="titleHallOfFame"
          style={{
            fontWeight: 800,
            fontSize: 26,
            color: "#582b71",
            letterSpacing: 1.1,
            marginBottom: 12,
            textAlign: "center",
            textShadow: "0 2px 10px #dccfef",
          }}
        >
          {showUserHallOfFamesComponents.showCongratTitle
            ? `${hofYear} Yılı Şeref Kürsüsü'nde Yer Almaya Hak Kazandınız! `
            : "Şeref Kürsüsü İçin Bilgileriniz Yüklenmiştir."}{" "}
          <br />
          <span
            style={{
              fontWeight: 500,
              display: "block",
              fontSize: 18,
              color: "#582b71",
              marginTop: 7,
            }}
          >
            {isHofUpdateOpen
              ? "21 Ekim 2026 Çarşamba saat 23.59'a kadar bilgilerinizi güncelleyebilirsiniz."
              : "Bilgi güncelleme süresi sona ermiştir."}
          </span>
        </p>
        {isHofUpdateOpen && !showUserHallOfFamesComponents.showCongratTitle && (
          <p
            style={{
              color: "#582b71",
              cursor: "pointer",
              fontSize: 16,
              textAlign: "center",
              marginTop: 16,
              textDecoration: "underline",
              fontWeight: 600,
            }}
            onClick={() =>
              setShowUserHallOfFamesComponents({
                showCongratTitle: false,
                showHallOfFameBox: true,
              })
            }
          >
            Bilgilerinizi yeniden güncellemek için tıklayın
          </p>
        )}

        {isHofUpdateOpen && showUserHallOfFamesComponents.showHallOfFameBox && (
          <>
            <div
              className="labelRow"
              style={{ gap: 26, alignItems: "flex-start", marginBottom: 28 }}
            >
              <div
                className="label"
                style={{ fontSize: 18, fontWeight: 600, color: "#582b71" }}
              >
                Fotoğraf
              </div>
              <div
                style={{
                  flex: 1,
                  minWidth: 200,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 24,
                }}
              >
                <div
                  style={{
                    background: "#fbf7fd",
                    border: "1.5px dashed #582b71",
                    boxShadow: "0 0 12px #efe7f6 inset",
                    borderRadius: 13,
                    height: 160,
                    width: 160,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {croppedImage ? (
                    <img
                      src={croppedImage}
                      style={{
                        height: 150,
                        width: 150,
                        borderRadius: 11,
                        objectFit: "cover",
                        border: "2px solid #582b71",
                      }}
                      alt="profile"
                    />
                  ) : (
                    <div
                      style={{
                        backgroundColor: "#f2eaf7",
                        height: "100%",
                        width: "100%",
                        borderRadius: 11,
                      }}
                    ></div>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="fileUploader"
                    style={{
                      fontWeight: 600,
                      color: "#582b71",
                      fontSize: 15,
                      cursor: "pointer",
                      background: "#ede2fa",
                      padding: "8px 22px",
                      borderRadius: 8,
                      border: "1.2px solid #582b71",
                    }}
                  >
                    Fotoğraf Yükle
                  </label>
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    ref={imageUploaderRef}
                    onChange={onFileChange}
                    id="fileUploader"
                    hidden
                    onClick={onFileInputClicked}
                  />
                  <div
                    style={{
                      fontSize: 12,
                      color: "#877aa3",
                      marginTop: 9,
                      maxWidth: 220,
                    }}
                  >
                    (Yükleme sonrası yandaki alanda önizleme görünür. Fotoğraf
                    karesini "Fotoğrafı Kullan" ile seçebilirsiniz.)
                  </div>
                </div>
              </div>
            </div>
            <div className="labelRowAbout" style={{ marginBottom: 24 }}>
              <div
                className="label"
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#582b71",
                  marginRight: 16,
                }}
              >
                Özgeçmişiniz
              </div>

              <TextField
                id="about"
                label="Özgeçmiş (En az 100 karakter)"
                name="about"
                value={about}
                onChange={(e) => {
                  if (e.target.value.length < 2000) setAbout(e.target.value);
                  else alert("Özgeçmişiniz 2000 karakterden uzun olamaz.");
                }}
                autoComplete={"disabled"}
                style={{
                  width: "90%",
                  background: "#f9f5fc",
                  borderRadius: 10,
                  border: "1.5px solid #582b71",
                }}
                size="small"
                error={about.length < 3}
                multiline
                rows={7}
                sx={{ mb: 3, ml: 1 }}
                inputProps={{ maxLength: 2000 }}
              />
            </div>
            <Button
              className="uploadButton"
              variant="contained"
              onClick={handleSubmitHallOfFameInfo}
              disabled={isHofInfoLoading}
              style={{
                fontWeight: 600,
                color: "#582b71",
                fontSize: 15,
                cursor: "pointer",
                background: "#ede2fa",
                padding: "8px 22px",
                borderRadius: 8,
                border: "1.2px solid #582b71",
              }}
            >
              {isHofInfoLoading ? "Kaydediliyor..." : "Kaydet"}
            </Button>
          </>
        )}
      </div>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Cropper
            image={imageSrc}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={4 / 4}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            style={{
              containerStyle: {
                width: 400,
                height: 300,
                border: "2px #582b71 solid",
                borderRadius: 18,
                marginLeft: window.innerWidth / 2 - 200,
                top: 30,
                background: "#f8f7fa",
              },
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{ color: "#582b71", fontWeight: 600 }}
          >
            Fotoğrafınızı kırpın ve "Fotoğrafı Kullan" butonuna tıklayın.
            Yakınlaştırmak için fare tekerleğini kullanın.
          </Typography>
          <Button
            sx={{
              mt: 5,
              width: 300,
              borderRadius: 12,
              fontWeight: 600,
              fontSize: 16,
              border: "1.3px solid #582b71",
            }}
            variant="contained"
            style={{
              background: "linear-gradient(90deg, #582b71 30%, #7ce5fd 120%)",
              color: "#fff",
            }}
            onClick={showCroppedImage}
          >
            Fotoğrafı Kullan
          </Button>
        </div>
      </Modal>
    </>
  );
};
const GenerateActiveProductBox = () => {
  const {
    refreshUserData,
    setCentralState,
    user,
    activeProduct,
    userDataLoadError,
  } = React.useContext(AppContext);
  const [isPurchseTriggered, setIsPurchaseTriggered] = useState(false);
  if (!user) return null;

  const activeExams = activeProduct?.exams || [];

  if (activeExams.length === 0) {
    return (
      <div className="activeProductBox">
        <h2>Şu an aktif sınav bulunmamaktadır.</h2>
      </div>
    );
  }

  const isAllCompulsaryFieldsFilled =
    user &&
    user.name &&
    user.birth_year &&
    user.gender &&
    user.city &&
    user.education &&
    user.occupation;

  let userProductData = user.products && user.products[activeProduct.id];

  const isPaymentSuccessfull = userProductData?.is_paid;

  let elemeResultId = "no_result";
  let elemeResultText = "";

  let yfResultId = "no_result";
  let yfResultText = "";

  let finalDerecesiId = "no_result";

  if (userProductData) {
    const { eleme_sonuc, yf_sonuc, final_derecesi } = userProductData;
    elemeResultId = eleme_sonuc || "no_result";
    yfResultId = yf_sonuc || "no_result";
    finalDerecesiId = final_derecesi || "no_result";
    elemeResultText =
      activeExams[0]?.result_texts?.[elemeResultId] ||
      activeExams[0]?.result_text?.[elemeResultId];
    yfResultText =
      activeExams[1]?.result_texts?.[yfResultId] ||
      activeExams[1]?.result_text?.[yfResultId];
  }

  const purchaseClicked = async () => {
    if (!user.name || !user.birth_year || !user.phone) {
      alert(
        "Ödeme adımına ilerlemeden önce lütfen ad-soyad, telefon ve doğum tarihi bilgilerinizi eksiksiz olarak doldurunuz."
      );
      return;
    }

    if (!activeProduct.payment_start_at) {
      alert("HATA: Ödeme başlangıç tarihi henüz belirlenmemiştir.");
      return;
    }
    if (activeProduct.payment_start_at > new Date()) {
      alert(
        "Ödeme aşaması henüz başlamamıştır. Takvimde belirtilen Birinci Aşama Sınavı başlangıç tarihinde ödeme yapabilirsiniz."
      );
      return;
    }
    if (!activeProduct.payment_end_at) {
      alert("HATA: Ödeme bitiş tarihi henüz belirlenmemiştir.");
      return;
    }
    if (activeProduct.payment_end_at < new Date()) {
      alert("HATA: Ödeme süresi sona ermiştir.");
      return;
    }

    setIsPurchaseTriggered(true);
    // Daha önce ödeme var mı kontrol edelim:
    let paymentToken =
      user.products && user.products[activeProduct.id]?.payment_token;
    if (paymentToken) {
      const pymnt = await getPayment(paymentToken);
      const isPaid = pymnt?.status === "successful";
      if (isPaid) {
        alert("Daha önce ödeme yapılmış. Sınavınız aktif hale getirilecektir.");
        const res = await markPaymentAsSuccessful(user.uid, activeProduct.id);
        if (res) {
          await refreshUserData();
        }
      } else {
        // alert("Token var ama ödeme yapılmamış.. Tokenı kullanarak ödeme sayfasına yönlendir.");
        const redirectUrl = HALICI_PAYMENT_HOST + "payments/" + paymentToken;
        window.location.href = redirectUrl;
      }
    } else {
      // alert("PAyment yok, backend'den url talep et.");
      const params = {
        receipt_id: 9999,
        user_id: 9999,
        name: user.name,
        email: user.email,
        uid: user.uid,
        requester_url: window.location.origin,
      };
      const paymentUrlResponse = await getPaymentUrl(params);
      // console.log("paymentUrlResponse", paymentUrlResponse);

      if (paymentUrlResponse.error_message) {
        alert(paymentUrlResponse.error_message);
      } else if (paymentUrlResponse.url) {
        //bunu kaydedelim ayrıca:
        const url = paymentUrlResponse.url;
        const arr = url.split("/");
        const tkn = arr[arr.length - 1];
        const newData = {
          products: { [activeProduct.id]: { payment_token: tkn } },
        };
        await saveUserData(user.uid, newData);
        window.location.href = url;
      } else
        alert("Ödeme ekranı açılırkan bir sorun oluştu. (Hata Kodu: BT91Z4)");
    }
    setIsPurchaseTriggered(false);
  };

  const lockScreenForPayment = (
    <div className="lock-screen">
      <div className="lock-screen-inner-box">
        <LockIcon style={{ fontSize: "xxx-large", marginBottom: 5 }} />
        <span>OYUN-2026 için kayıt ve ödeme süreci sona ermiştir.</span>
        {/*<span>SINAVLARA ERİŞEBİLMEK İÇİN LÜTFEN ÖDEME YAPINIZ</span>
        <Button
          className="purchaseButton"
          variant="contained"
          color="secondary"
          disabled={isPurchseTriggered}
          onClick={purchaseClicked}
        >
          {isPurchseTriggered ? "Lütfen Bekleyiniz" : "Ödeme Sayfası"}
        </Button>*/}
      </div>
    </div>
  );

  const lockScreenForProfileData = (
    <div className="lock-screen">
      <div className="lock-screen-inner-box">
        <LockIcon style={{ fontSize: "xxx-large", marginBottom: 5 }} />
        <span> LÜTFEN EKSİK PROFİL BİLGİLERİNİZİ GÜNCELLEYİNİZ.</span>
      </div>
    </div>
  );

  const elemeAdditionalComponents = activeProduct?.id === "oyun2026" && (
    <>
      {/* İtiraz formu son itiraz tarihi geçtiği için yorum satırına alındı.
      <div
        style={{
          marginTop: 20,
          padding: "20px 24px",
          border: "2px solid #582b71",
          borderRadius: 10,
          background: "#f5f0f9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          textAlign: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 22 }}>📝</span>
          <div style={{ fontWeight: 700, fontSize: 15, color: "#582b71" }}>
            Soru İtirazı
          </div>
        </div>
        <div style={{ fontSize: 13, color: "#555" }}>
          Eleme sınavı sorularına itiraz etmek için formu doldurunuz. Son itiraz
          tarihi <strong>31 Temmuz 2026 Cuma, saat 13.00’dır.</strong> Bu
          tarihten sonra yapılacak itirazlar değerlendirmeye alınmayacaktır.
        </div>
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://docs.google.com/forms/d/e/1FAIpQLSeQhdIJ1hxwvSpFeg6i0HLEQP2K5HzM0eTc_AcK7KBdT1GtQw/viewform?usp=pp_url&entry.1157331533=${user.uid}&entry.427270648=${user.email}`}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{
              fontWeight: 700,
              fontSize: 13,
              borderRadius: 8,
              textTransform: "none",
            }}
          >
            İtiraz Formuna Git →
          </Button>
        </a>
      </div>
      */}

      {/* <p className="small-announcement">
        Tüm Oyun2024 duyuruları, hatırlatmalar, yaklaşan sınav tarihleri ve
        itiraz süreci gibi önemli açıklamalar, Whatsapp duyuru kanalımız
        aracılığıyla yapılacaktır. Aşağıdaki bağlantıyı kullanarak kanalımıza
        katılabilirsiniz. Telefon numaranız diğer üyelerle paylaşılmayacaktır.
        İstediğiniz zaman kanaldan çıkabilirsiniz.
      </p>
      <p>
        <a
          href="https://whatsapp.com/channel/0029VabTkl305MUjehocPd0S"
          target="_blank"
          rel="noreferrer"
        >
          Whatsap Duyuru Kanalı
        </a>
      </p>
      <p className="small-announcement">
        (Kanala üye olduktan sonra kanal ayarlarından bildirimleri açmayı
        unutmayınız.)
      </p>
*/}
      {/* <a
        target={"_blank"}
        style={{ marginTop: 23 }}
        rel="noreferrer"
        href={`https://docs.google.com/forms/d/e/1FAIpQLScHZ_jF5t-1dRXAlwLM0RZSXYob2ilp4sM4GezIoywOMm94PA/viewform?usp=pp_url&entry.1157331533=${user.uid}&entry.427270648=${user.email}`}
      >
        Sorulara İtirazlarınızı iletmek için tıklayınız.
      </a> 
      {/* {elemeResultId === 1 && <SuccessDocument2023 userName={user.name} />} */}
      {/* {elemeResultId === 2 && <AttendanceDocument2023 userName={user.name} />} */}
      {/* {(elemeResultId === 2 || (elemeResultId === 1 && yfResultId !== 1)) && // TODO: seneye eleme kesin sonuçları yayınlandığı anda bu satır yüzünden elemede başarılı olanlara sebf linki gösterilir. Bunu engellemek için OR kısımını silip sadece eleme_res_id==2 olanlara sebf verecek şekilde deploy yap.
        (user.birth_year || 0) > 2004 && ( //İlk 2 turda elenen genç-çocuk-miniklere sosyal etkinlik formlarını verelim. (
          <ElemeSebfDocument2023
            userName={user.name}
            fileNumber={user.products.oyun2023.file_number}
          />
        )} */}
      {elemeResultText && (
        <div
          style={{
            marginTop: 20,
            padding: "20px 24px",
            borderRadius: 12,
            textAlign: "center",
            fontWeight: 800,
            fontSize: 18,
            lineHeight: 1.4,
            whiteSpace: "pre-line",
            border: `2px solid ${elemeResultId === 1 ? "#2e7d32" : "#b3261e"}`,
            background: elemeResultId === 1 ? "#e6f4ea" : "#fdecea",
            color: elemeResultId === 1 ? "#2e7d32" : "#b3261e",
          }}
        >
          {elemeResultText}
        </div>
      )}
    </>
  );

  const yfAdditionalComponets = activeProduct?.id === "oyun2026" && (
    <>
      {/*<div
        style={{
          marginTop: 20,
          padding: "20px 24px",
          border: "2px solid #582b71",
          borderRadius: 10,
          background: "#f5f0f9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          textAlign: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 22 }}>📝</span>
          <div style={{ fontWeight: 700, fontSize: 15, color: "#582b71" }}>
            Soru İtirazı
          </div>
        </div>
        <div style={{ fontSize: 13, color: "#555" }}>
          Yarı Final Sınavı sorularına itiraz etmek için formu doldurunuz. Son
          itiraz tarihi <strong>3 Eylül 2026 Perşembe, saat 23.59'dur.</strong>{" "}
          Bu tarihten sonra yapılacak itirazlar değerlendirmeye alınmayacaktır.
        </div>
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://docs.google.com/forms/d/e/1FAIpQLSfkvBoJTG6JlbsT3jMQI033DK7Iez1s3XJYEjwdPTQ88bqyKA/viewform?usp=pp_url&entry.1157331533=${user.uid}&entry.427270648=${user.email}`}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{
              fontWeight: 700,
              fontSize: 13,
              borderRadius: 8,
              textTransform: "none",
            }}
          >
            İtiraz Formuna Git →
          </Button>
        </a>
      </div>

      {/*    <
        target={"_blank"}
        style={{ marginTop: 23 }}
        rel="noreferrer"
        href={`https://docs.google.com/forms/d/e/1FAIpQLSe983rZg1NrnUi0gSdmTaeAHILrWy8zYMLYrz19GztC9_zcnA/viewform?usp=pp_url&entry.1157331533=${user.uid}&entry.427270648=${user.email}`}
      >
        Sorulara İtirazlarınızı iletmek için tıklayınız.
      </a> }

      {/* {yfResultId === 1 && <YFSuccessDocument2022 userName={user.name} />} */}

      {/*  {finalDerecesiId === "no_result" && (user.birth_year || 0) > 2004 && (
        <ElemeSebfDocument2023
          userName={user.name}
          fileNumber={user.products.oyun2023?.file_number}
        />
      )}*/}

      {yfResultText && (
        <div
          style={{
            marginTop: 20,
            padding: "20px 24px",
            borderRadius: 12,
            textAlign: "center",
            fontWeight: 800,
            fontSize: 18,
            lineHeight: 1.4,
            whiteSpace: "pre-line",
            border: `2px solid ${
              userProductData?.yf_sonuc === 1 ? "#2e7d32" : "#b3261e"
            }`,
            background: userProductData?.yf_sonuc === 1 ? "#e6f4ea" : "#fdecea",
            color: userProductData?.yf_sonuc === 1 ? "#2e7d32" : "#b3261e",
          }}
        >
          {yfResultText}
        </div>
      )}
    </>
  );

  const publicInformationUrlButton = async () => {
    // const publicInformationFileUrl = await getPublicUrlOfFile(
    //   "2023_public/1_final_sinavi/FİNAL SINAVI BİLGİLENDİRME NOTU.pdf"
    // );
    // fetchFileFromUrl(publicInformationFileUrl);
    // console.log("file_url: ", publicInformationFileUrl);
  };

  const onClickAnswerKeys = async () => {
    const publicInformationFileUrl = await getPublicUrlOfFile(
      "2026_public/1_final_sinavi/FİNAL SINAVI CEVAP ANAHTARLARI.pdf"
    );
    if (!publicInformationFileUrl) {
      alert("Final Sınavı cevap anahtarı henüz yayınlanmadı.");
      return;
    }
    fetchFileFromUrl(publicInformationFileUrl);

    // console.log("file_url: ", publicInformationFileUrl);
  };

  // Final Sınavı kategorisi (Minikler, Çocuklar vb.) doğum yılına göre bulunur.
  const finalCategoryName =
    (activeExams[2]?.exam_access_ids || []).find(
      (c) =>
        user?.birth_year >= c.birth_year_start &&
        user?.birth_year <= c.birth_year_end
    )?.category || "";
  const isMiniklerOrCocuklar = /minik|çocuk/.test(
    finalCategoryName.toLocaleLowerCase("tr")
  );

  const publicInformationButton = user && (
    <div className="infoBox" style={{ marginTop: 10, marginBottom: 10 }}>
      <h3 className="infoBoxTitle">Final Sınavı Bilgilendirme</h3>
      <div className="infoBoxContent">
        <p style={{ marginBottom: 16, fontSize: "0.95em", color: "#000" }}>
          Final Sınavı hakkında önemli bilgiler, sınav kuralları, tarih ve saat
          bilgileri ile diğer detayları içeren bilgilendirme notunu aşağıdaki
          butona tıklayarak indirebilirsiniz. Sınav Salonu Bilgilendirme için
          belgenizi indirip sınav günü yanınızda getirebilirsiniz.
        </p>
        {isMiniklerOrCocuklar && (
          <p
            style={{
              marginBottom: 16,
              padding: "12px 16px",
              borderRadius: 10,
              background: "#f5f0f9",
              border: "2px solid #582b71",
              fontSize: "0.95em",
              color: "#000",
            }}
          >
            Minikler ve Çocuklar kategorisindeki yarışmacılar, sınav sonrasında{" "}
            <strong>12.10'da</strong> sınıflardan çıkarılacaktır. Velilerin,
            yarışmacıları karşılamak üzere 12.10'dan itibaren sınıfların önünde
            bulunmalarını öneririz.
          </p>
        )}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            alignItems: "flex-start",
          }}
        >
          {/* Final Sınavı Cevap Anahtarı şu an kapalı.
          <a
            href="https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2025_public%2F1_final_sinavi%2FF%C4%B0NAL%20SINAVI%20CEVAP%20ANAHTARLARI.pdf?alt=media&token=325dfce8-fca5-48e3-8942-2571b4228b27"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            <Button
              style={{
                minWidth: 280,
                height: 60,
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                padding: "12px 24px",
              }}
              color="secondary"
              variant="contained"
            >
              Final Sınavı Cevap Anahtarı
            </Button>
          </a> */}
          <a
            href="https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2026_public%2F1_final_sinavi%2FOYUN%202026%20F%C4%B0NAL%20SINAVI%20B%C4%B0LG%C4%B0LEND%C4%B0RME%20NOTU%20(2).pdf?alt=media&token=f4017373-c418-434d-a807-a92f8bf6784f"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            <Button
              style={{
                minWidth: 280,
                height: 60,
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                padding: "12px 24px",
              }}
              color="secondary"
              variant="contained"
              onClick={publicInformationUrlButton}
            >
              Final Sınavı Bilgilendirme Notu
            </Button>
          </a>
          {userProductData?.exam_room_info && (
            <SinavSalonuDocument2026
              userName={user.name}
              email={user.email}
              examRoomInfo={userProductData.exam_room_info}
            />
          )}
        </div>
      </div>
    </div>
  );

  const answerKeys = user && (
    <div style={{ marginTop: 10 }}>
      <a
        href="https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2024_public%2F1_final_sinavi%2FCevap%20anahtar%C4%B1.pdf?alt=media&token=9c5913b6-9cd7-4d30-8f2f-24008405b4d7"
        target="_blank"
        rel="noreferrer"
      >
        <Button
          style={{
            width: 180,
            height: 60,
          }}
          color="secondary"
          variant="contained"
          // onClick={onClickAnswerKeys}
        >
          FİNAL SINAVI CEVAP ANAHTARLARI
        </Button>
      </a>
    </div>
  );

  const dereceXlsx = user && (
    <div style={{ marginTop: 10 }}>
      <a
        href="https://docs.google.com/spreadsheets/d/1YTcuLvyWOI-0Iu2Nes1ToU6f7-sBYnzz/edit?usp=sharing&ouid=101457187378283704471&rtpof=true&sd=true"
        target="_blank"
        rel="noreferrer"
      >
        <Button
          style={{
            width: 280,
            height: 100,
          }}
          color="secondary"
          variant="contained"
          //onClick={onClickAnswerKeys}
        >
          YARIŞMACILARIN DOĞRU CEVAPLARI VE DERECELERİ
        </Button>
      </a>
    </div>
  );

  const dereceInformation = user && (
    <div style={{ marginTop: 10 }}>
      <Button
        style={{
          width: 280,
          height: 100,
        }}
        color="secondary"
        variant="contained"
        //onClick={onClickAnswerKeys}
      >
        Final sınavına ait dereceler ve belgeler ilerleyen günlerde
        yayınlanacaktır.
      </Button>
    </div>
  );
  // Final Sınavı puan itiraz formu bu tarihten sonra otomatik olarak gizlenir.
  const isFinalObjectionOpen = new Date() < FINAL_OBJECTION_DEADLINE;

  const fnAdditionalComponets = activeProduct?.id === "oyun2026" && (
    <>
      {/* {dereceXlsx} 
        {answerKeys}
        */}
      {/* {dereceInformation} */}
      {/* Kategori sırası gösterilir; toplam katılımcı sayısı verilmez, 0 puanlılara gösterilmez */}
      {userProductData?.final_derecesi >= 1 &&
        userProductData?.final_puan > 0 && (
          <div
            style={{
              marginTop: 10,
              marginBottom: 16,
              padding: "16px 20px",
              border: "2px solid #582b71",
              borderRadius: 10,
              background: "#fff",
              fontSize: 16,
              color: "#582b71",
              textAlign: "center",
            }}
          >
            Final Sınavı'nda kategorinizde{" "}
            <strong style={{ fontSize: 20 }}>
              {userProductData.final_derecesi}.
            </strong>{" "}
            oldunuz.
            <br />
            Türkiye 31. Zeka Oyunları Yarışması - OYUN-2026'ya göstermiş
            olduğunuz ilgi ve final katılımınız için teşekkür ederiz.
          </div>
        )}
      <div
        style={{
          marginTop: 10,
          marginBottom: 16,
          padding: "16px 20px",
          border: "2px solid #582b71",
          borderRadius: 10,
          background: "#f5f0f9",
          fontSize: 14,
          lineHeight: 1.6,
          color: "#000",
          textAlign: "center",
        }}
      >
        <strong>Ödül Töreni:</strong> 10 Ekim 2026 Cumartesi, saat{" "}
        <strong>16.00</strong>'da yapılacaktır.
        <br />
        İlk 10'a giren yarışmacılar <strong>gelecek hafta</strong> sistem
        üzerinden açıklanacaktır.
      </div>
      <div style={{ marginBottom: 16, marginTop: 10 }}>
        <a
          href="https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2026_public%2FF%C4%B0NAL%20CEVAP%20ANAHTARLARI.pdf?alt=media&token=c75b2b41-7d19-48a1-a0c8-e480d619420c"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", display: "inline-block" }}
        >
          <Button
            color="secondary"
            variant="contained"
            style={{
              minWidth: 240,
              height: 50,
              fontWeight: "bold",
              fontSize: 15,
              textTransform: "none",
              padding: "9px 22px",
              borderRadius: 10,
              letterSpacing: 0.4,
              backgroundColor: "#582b71",
              boxShadow: "0 1.5px 10px #cab4e6",
            }}
          >
            Final Sınavı Cevap Anahtarlarını İndir
          </Button>
        </a>
      </div>
      {isFinalObjectionOpen && (
        <div
          style={{
            marginTop: 20,
            padding: "20px 24px",
            border: "2px solid #582b71",
            borderRadius: 10,
            background: "#f5f0f9",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 12,
            textAlign: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 22 }}>📝</span>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#582b71" }}>
              Puan İtirazı
            </div>
          </div>
          <div style={{ fontSize: 13, color: "#555" }}>
            Final Sınavı puanlarınıza itiraz etmek için formu doldurunuz. Son
            itiraz tarihi{" "}
            <strong>10 Ekim 2026 Cumartesi, saat 15.30'dur.</strong> Bu tarihten
            sonra yapılacak itirazlar değerlendirmeye alınmayacaktır.
          </div>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://docs.google.com/forms/d/e/1FAIpQLScmZi2JTbS_vAufwquPJIgWMEGpMo6EvjkF_2jYZWGu0rfJvw/viewform?usp=dialog"
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="secondary"
              style={{
                fontWeight: 700,
                fontSize: 13,
                borderRadius: 8,
                textTransform: "none",
              }}
            >
              İtiraz Formuna Git →
            </Button>
          </a>
        </div>
      )}
      {/* <a
        target={"_blank"}
        style={{ marginTop: 23 }}
        rel="noreferrer"
        href={
          "https://docs.google.com/forms/d/e/1FAIpQLSeUKHmsKoBWji5dbKLP9Ocm7_JHz_uNC8MougwaHm6zw5yk0w/viewform?usp=pp_url&entry.427270648=" +
          user.email
        }
      >
        Sorulara İtirazlarınızı iletmek için tıklayınız.
      </a> */}

      {/* {yfResultId === 1 && (user.birth_year || 0) > 2003 && (
        <FinalSebfDocument2022
          userName={user.name}
          fileNumber={user.products.oyun2022.file_number}
        />
      )}
      {yfResultId === 1 && <YFSuccessDocument2022 userName={user.name} />}

      {yfResultText && (
        <span
          style={{ marginTop: 15, color: "red", textDecoration: "underline" }}
        >
          {yfResultText}
        </span>
      )}
      {yfResultId === 1 && <YFSuccessDocument2023 userName={user.name} />}
      {finalDerecesiId > 0 && (user.birth_year || 0) > 2004 && (
        <FinalSebfDocument2023
          userName={user.name}
          fileNumber={user.products.oyun2023.file_number}
        />
      )} */}
    </>
  );

  return (
    <div className="activeProductBox">
      {activeProduct?.id === "oyun2026" &&
        yfResultId === 1 &&
        publicInformationButton}

      {!userDataLoadError &&
        !isAllCompulsaryFieldsFilled &&
        lockScreenForProfileData}
      {isAllCompulsaryFieldsFilled &&
        !isPaymentSuccessfull &&
        lockScreenForPayment}
      <h2>{activeProduct.header}</h2>
      {/* Aşamalar ters sırada: Final (3. aşama) en üstte, Eleme (1. aşama) en altta. */}
      {[...activeExams.keys()].reverse().map((idx) => {
        const e = activeExams[idx];
        if (idx > 0 && !isPaymentSuccessfull) return null;
        else if (idx > 0 && elemeResultId === 2) return null;
        else if (idx === 2 && activeProduct?.id === "oyun2025") {
          // Final Sınavı sadece total_rank 1-100 arasındaysa görünür (1 ve 100 dahil)
          const totalRank = user.products?.[activeProduct.id]?.total_rank;
          if (
            totalRank === undefined ||
            totalRank === null ||
            totalRank < 1 ||
            totalRank > 100
          ) {
            return null;
          }
        } else if (idx === 2 && yfResultId !== 1) {
          // Final Sınavı sadece Yarı Final'de başarılı (yf_sonuc === 1) olanlara gösterilir.
          return null;
        }
        let examId = "";
        let examQuestionsId = "";
        let exam_access_ids = e.exam_access_ids || [];
        // Final Sınavı (idx 2) butonu available_at beklenmeden finalistlere açık.
        let availableAtDateHasCome =
          idx === 2 || (e.available_at && e.available_at.toDate() < new Date());

        let categoryName = "";
        exam_access_ids.forEach((exam_category) => {
          const {
            birth_year_start,
            birth_year_end,
            exam_id,
            exam_questions_id,
            category,
          } = exam_category;
          if (
            user.birth_year >= birth_year_start &&
            user.birth_year <= birth_year_end
          ) {
            examId = exam_id;
            examQuestionsId = exam_questions_id;
            categoryName = category;
          }
        });

        let linkReady = examId && examQuestionsId;

        const userName = user?.name || "";

        const nameForUrl = userName.trim().replaceAll(" ", "+");
        let osis_link =
          "https://sinav.tzv.org.tr/linkedExam/" +
          examId +
          "&" +
          examQuestionsId +
          "&" +
          user.uid +
          "&" +
          nameForUrl;

        const examTitle = (
          <h3 style={{ margin: 0 }}>
            {e.title + (categoryName ? " (" + categoryName + ")" : "")}
          </h3>
        );

        const examExpo = (
          <p style={{ textAlign: "justify", whiteSpace: "pre-line" }}>
            {e.expo}
          </p>
        );

        const startExamButton = linkReady &&
          availableAtDateHasCome &&
          isPaymentSuccessfull && (
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              href={osis_link}
              rel="noreferrer"
            >
              <Button color="secondary" variant="contained">
                Sınav Ekranı
              </Button>
            </a>
          );

        const properExamLinkNotFoundExplanation = availableAtDateHasCome &&
          isPaymentSuccessfull && <span>Sınav Kategoriniz Belirlenemedi</span>;

        return (
          <div key={idx + "exam_box"} className="examBox">
            {examTitle}
            {examExpo}
            {idx === 2 && startExamButton}
            {idx === 0 && elemeAdditionalComponents}
            {idx === 1 && yfAdditionalComponets}
            {idx === 2 && fnAdditionalComponets}
            {!linkReady && properExamLinkNotFoundExplanation}
          </div>
        );
      })}

      <div>{activeProduct.bottom_note}</div>
    </div>
  );
};
